import React, { useState } from "react";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import PaperDraggable from "@icarius-common/paperDraggable";
import { CloseIcon } from "@icarius-icons";
import { getLocalizedString } from "@icarius-localization/strings";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tabs,
  Tab,
} from "@material-ui/core";
import TabTasks from "../tabs/tabTasks";
import TabResponsibilities from "../tabs/tabResponsibilities";
import TabExpectedResults from "../tabs/tabExpectedResults";
import TabIntellectualRequirements from "../tabs/tabIntellectualRequirements";
import TabPhysicalRequirements from "../tabs/tabPhysicalRequirements";
import TabWorkConditions from "../tabs/tabWorkConditions";
import TabGeneral from "../tabs/tabGeneral";
import TabCompetencies from "../tabs/tabCompetencies";

const DetailsEditDialog = (props) => {
  const [activeTab, setActiveTab] = useState(0);

  const {
    dialogIsOpen,
    editMode,
    currentNode,
    dialogTitle,
    handleChangeField,
    cancelRefClick,
    closeRefClick,
    saveRefClick,
    positionClassifications,
    competencyGroupList,
    evaluationGroupList,
    orgChart,
    frequencies,
    responsibilityTypes,
    intellectualRequirementTypes,
    physicalRequirementTypes,
    workConditionTypes,
    color,
    theme,
    skillList,
    targetList,
  } = props;

  const getTitle = () => {
    if (dialogTitle) return dialogTitle;
    if (editMode) return getLocalizedString("editPosition");
    return getLocalizedString("viewPosition");
  }

  return (
    <Dialog
      open={dialogIsOpen}
      PaperComponent={PaperDraggable}
      maxWidth={"md"}
      fullWidth>
      <div className={"dialog-container"}>
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {getTitle()}
          <DialogTitleDivider />
        </DialogTitle>
        <CloseIcon className={"dialog-close-icon icon"} onClick={editMode ? cancelRefClick : closeRefClick} />
        <DialogContent>
          {
            currentNode &&
            <>
              <Tabs
                value={activeTab}
                onChange={(e, newValue) => setActiveTab(newValue)}
                variant="scrollable"
                scrollButtons="auto"
                className="whiteText"
                classes={{ indicator: 'bg-white' }}
                style={{ minHeight: 48 }}
              >
                <Tab label={getLocalizedString("general")} />
                <Tab label={getLocalizedString("notes")} />
                <Tab label={getLocalizedString("responsibilities")} />
                <Tab label={getLocalizedString("expectedResults")} />
                <Tab label={getLocalizedString("intellectualRequirements")} />
                <Tab label={getLocalizedString("physicalRequirements")} />
                <Tab label={getLocalizedString("workConditions")} />
                <Tab label={getLocalizedString("competencies")} />
              </Tabs>
              <div style={{ padding: '16px 0', minHeight: '60vh' }}>
                {activeTab === 0 && (
                  <TabGeneral
                    editMode={editMode}
                    currentNode={currentNode}
                    handleChangeField={handleChangeField}
                    positionClassifications={positionClassifications}
                    competencyGroupList={competencyGroupList}
                    evaluationGroupList={evaluationGroupList}
                    orgChart={orgChart}
                  />
                )}
                {activeTab === 1 && (
                  <TabTasks
                    editMode={editMode}
                    currentNode={currentNode}
                    handleChangeField={handleChangeField}
                    frequencies={frequencies}
                    color={color}
                    theme={theme}
                  />
                )}
                {activeTab === 2 && (
                  <TabResponsibilities
                    editMode={editMode}
                    currentNode={currentNode}
                    handleChangeField={handleChangeField}
                    responsibilityTypes={responsibilityTypes}
                    color={color}
                    theme={theme}
                  />
                )}
                {activeTab === 3 && (
                  <TabExpectedResults
                    editMode={editMode}
                    currentNode={currentNode}
                    handleChangeField={handleChangeField}
                    color={color}
                    theme={theme}
                  />
                )}
                {activeTab === 4 && (
                  <TabIntellectualRequirements
                    editMode={editMode}
                    currentNode={currentNode}
                    handleChangeField={handleChangeField}
                    intellectualRequirementTypes={intellectualRequirementTypes}
                    color={color}
                    theme={theme}
                  />
                )}
                {activeTab === 5 && (
                  <TabPhysicalRequirements
                    editMode={editMode}
                    currentNode={currentNode}
                    handleChangeField={handleChangeField}
                    physicalRequirementTypes={physicalRequirementTypes}
                    color={color}
                    theme={theme}
                  />
                )}
                {activeTab === 6 && (
                  <TabWorkConditions
                    editMode={editMode}
                    currentNode={currentNode}
                    handleChangeField={handleChangeField}
                    workConditionTypes={workConditionTypes}
                    color={color}
                    theme={theme}
                  />
                )}
                {activeTab === 7 && (
                  <TabCompetencies
                    editMode={editMode}
                    currentNode={currentNode}
                    handleChangeField={handleChangeField}
                    competencyGroupList={competencyGroupList}
                    skillList={skillList}
                    targetList={targetList}
                    color={color}
                    theme={theme}
                  />
                )}
              </div>
            </>
          }
        </DialogContent>
      </div>
      <DialogActions>
        {
          editMode &&
          <ButtonDialogAction onClick={cancelRefClick} text={getLocalizedString("cancel")} />
        }
        {
          !editMode &&
          <ButtonDialogAction onClick={closeRefClick} text={getLocalizedString("close")} />
        }
        {
          editMode &&
          <ButtonDialogAction onClick={saveRefClick} isAccept text={getLocalizedString("agree")} />
        }
      </DialogActions>
    </Dialog>
  )
}

export default DetailsEditDialog;